<p-colorPicker
  [(ngModel)]="_color"
  (ngModelChange)="colorChange.emit($event)"
  [inline]="inline"></p-colorPicker>
